import React from 'react';
import { motion } from 'framer-motion';
import {
  Box,
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

export default function FAQ() {
  const faqs = [
    {
      question: "What services do you provide in Rajkot?",
      answer: "We provide comprehensive Taxation services including GST registration & filing, income tax filing, business registration, accounting & bookkeeping, and financial consultation. We also offer loan assistance services.",
    },
    {
      question: "How long does it take to get GST registration in Rajkot?",
      answer: "GST registration typically takes 3-7 working days once all documents are submitted. We ensure quick processing and follow-up with the GST department for timely registration.",
    },
    {
      question: "What documents are required for income tax filing?",
      answer: "For income tax filing, you need PAN card, Aadhaar card, Form 16 (if salaried), bank statements, investment proofs, and details of other income sources. We guide you through the entire documentation process.",
    },
    // {
    //   question: "Do you provide home visit services in Rajkot?",
    //   answer: "Yes, we provide consultation services at your office or home in Rajkot. Please contact us to schedule an appointment.",
    // },
    {
      question: "What are your consultation charges?",
      answer: "Our charges vary based on the service required. Please contact us for more details. We offer competitive pricing for all services in Rajkot.",
    },
    {
      question: "When will Home Loan services be available?",
      answer: "Our Home Loan & Subsidy Services are launching soon. Please contact us or submit a loan inquiry form to be notified when these services become available.",
    },
  ];

  return (
    <Box component="section" id="faq" sx={{ py: { xs: 10, md: 12 }, bgcolor: 'grey.50' }}>
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Chip
              label="FAQ"
              sx={{
                mb: 2,
                bgcolor: 'rgba(30, 91, 92, 0.1)',
                color: 'rgba(30, 91, 92, 1)',
                fontWeight: 500
              }}
            />
            <Typography
              variant="h3"
              component="h2"
              sx={{ fontWeight: 'bold', mb: 2, fontSize: { xs: '2rem', md: '2.5rem' } }}
            >
              Frequently Asked Questions
            </Typography>
            <Typography
              variant="body1"
              sx={{ color: 'text.secondary', maxWidth: '32rem', mx: 'auto' }}
            >
              Find answers to common questions about our services.
            </Typography>
          </Box>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <Box sx={{ maxWidth: '48rem', mx: 'auto' }}>
            {faqs.map((faq, index) => (
              <Accordion key={index} sx={{ mb: 1 }}>
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  sx={{ '& .MuiAccordionSummary-content': { textAlign: 'left' } }}
                >
                  <Typography variant="h6" sx={{ fontWeight: 500 }}>
                    {faq.question}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography sx={{ color: 'text.secondary', lineHeight: 1.7 }}>
                    {faq.answer}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        </motion.div>
      </Container>
    </Box>
  );
}